var SCM = SCM || {};

var treeNodeCollapsed = 'treeNodeCollapsed';
var treeNodeExpanded = 'treeNodeExpanded';

(function (issues, $) {
     issues.setActiveJumplink = function () {
        $('.section-jump-link').on('click', function () {
            $('.section-jump-link').removeClass('active');
            $(this).closest('.section-jump-link').addClass('active');
        });
    };

    issues.toggleNestedJumplinks = function() {
        var $jumplinkArrow = $('.section-jump-link .list-toggle, .section-jump-link .mobile-list-toggle');

        $jumplinkArrow.on('click', function (e) {
            e.preventDefault();
            toggleParentNode($(this));
        });
    };

    issues.onIssueHeadingClick = function ($currentNavTreeLink) {
        toggleParentNode($currentNavTreeLink.prev('.js-nav-tree-toggle'));
    };

    function toggleParentNode($this) {
        var $nearestSublist = $this.parents('.section-jump-link__link-wrap').siblings('ul.section-jump-link__sublist'),
            $interactiveTreeItem = $this.next('[role="treeitem"]'),
            $parentListItem = $this.closest('li'),
            $screenReader = $this.children('.js-toggle-sublist');

        var arrowRight = $this.hasClass('mobile-list-toggle') ? 'icon-general_arrow-right' : 'icon-general-arrow-filled-right',
            arrowDown = $this.hasClass('mobile-list-toggle') ?  'icon-general_arrow-down' : 'icon-general-arrow-filled-down';

        if ($interactiveTreeItem.attr('aria-expanded') === 'false') {
            $this.removeClass(arrowRight).addClass(arrowDown);
            $parentListItem.removeClass(treeNodeCollapsed).addClass(treeNodeExpanded);
            $screenReader.text('Collapse');
        } else if ($interactiveTreeItem.attr('aria-expanded') === 'true') {
            $this.removeClass(arrowDown).addClass(arrowRight);
            $parentListItem.removeClass(treeNodeExpanded).addClass(treeNodeCollapsed);
            $screenReader.text('Expand');
        }

        toggleAriaExpanded($interactiveTreeItem);

        $nearestSublist.slideToggle();
        $nearestSublist.attr('aria-hidden') === 'false' ? $nearestSublist.attr('aria-hidden', 'true') : $nearestSublist.attr('aria-hidden', 'false');
    }

    function toggleAriaExpanded($interactiveTreeItem) {
        $interactiveTreeItem.attr('aria-expanded') === 'false' ? $interactiveTreeItem.attr('aria-expanded', 'true') : $interactiveTreeItem.attr('aria-expanded', 'false');
    }

    issues.selectCurrentNodeOnClick = function () {
        var $treeInteractive = $('.js-tree a');

        $treeInteractive.on('click', function () {
            var $currentNode = $(this).closest('.js-tree').find('*[aria-current]');
            var $selectedNode = $(this);

            $('.js-tree').removeAttr('tabindex');
            $treeInteractive.not($selectedNode).attr('tabindex', '-1');

            if (!$selectedNode.is('[aria-current]')) {
                $currentNode.removeAttr('aria-current');
                $selectedNode.attr('aria-current', 'true')
                    .attr('tabindex', '0');
            }

            $selectedNode.focus();
            if (window.location.href.indexOf('#') == -1) {
                var url = $(this).attr('href');
                var hash = url.substring(1);

                var yloc = $('#' + hash).offset().top;

                $('html, body').stop().animate({
                    scrollTop: yloc
                }, 850);
            }
        });
    };

    // Hide everything that doesn't match what is entered into the .issue-topic__input textbox
    issues.filterTopicTerms = function () {
        $('.issue-topic__input').keyup(function () {
            $('.issue-topic__term').hide();
            var term = $(this).val();
            var allLower = term.toLowerCase();

            $.extend($.expr[':'], {
                'containsIN': function (elem, i, match) {
                    return (elem.textContent || elem.innerText || '').toLowerCase().indexOf((match[3] || '').toLowerCase()) >= 0;
                }
            });

            $(".issue-topic__term:containsIN('" + allLower + "')").show();

            if (term === null || term === '') {
                $('.issue-topic__term').show();
            }
        });
    };

    // go to selected Issue/Year/Decade as determined by option value (URL)
    issues.updateIssueBrowseOnChange = function () {
        $('.issue-browse-select').on('change', function () {
            window.location.href = $(this).val();
        });
    };

})(SCM.Issues = SCM.Issues || {}, jQuery);

jQuery(document).ready(function ($) {
    SCM.Issues.filterTopicTerms();
    SCM.Issues.toggleNestedJumplinks();
    SCM.Issues.updateIssueBrowseOnChange();
    SCM.Issues.selectCurrentNodeOnClick();

    if (window.location.hash) {
        $('.js-jumplink[href="' + window.location.hash + '"]')
            .addClass('active')
            .attr('aria-current', 'true')
            .attr('tabindex', '0')
            .parents('.section-jump-link')
            .slice(1)
            .children('.section-jump-link__link-wrap')
            .children('.list-toggle')
            .click();

        $('.js-tree').removeAttr('tabindex');
    }

    var viewportWidth = SCM.SiteJS.getViewportWidth();
    var isMobile = viewportWidth <= 900;
    if (isMobile)
    {
        $('#IssuesList > option').each(function () {
            var text = $(this).text();
            var length = text.length;
            var cutoffIndex = 47;

            if (length > cutoffIndex)
            {
                var lastSpace = text.substr(0, cutoffIndex).lastIndexOf(' ');
                if (lastSpace > 0)
                {
                    var truncatedText = text.substr(0, lastSpace) + '...';
                    $(this).text(truncatedText);
                }
            }
        });
    }
});